import { api } from '@/lib/api';
import type {
  User,
  PaginatedUsers,
  UserFilters,
  PaginationParams,
  CreateUserDto,
  UpdateUserDto,
} from '../types/user.types';

const BASE_URL = '/users';

/**
 * Service pour les Users
 */
export const usersService = {
  /**
   * Récupère la liste paginée des utilisateurs avec filtres
   */
  async getAll(
    filters: UserFilters = {},
    pagination: Partial<PaginationParams> = {}
  ): Promise<PaginatedUsers> {
    const params = new URLSearchParams();

    // Pagination
    params.set('page', String(pagination.page || 1));
    params.set('limit', String(pagination.limit || 20));
    if (pagination.sortBy) params.set('sortBy', pagination.sortBy);
    if (pagination.sortOrder) params.set('sortOrder', pagination.sortOrder);

    // Filtres
    if (filters.search) params.set('search', filters.search);
    if (filters.role) params.set('role', filters.role);
    if (filters.status) params.set('status', filters.status);
    if (filters.companyId) params.set('companyId', String(filters.companyId));

    const response = await api.get<PaginatedUsers>(
      `${BASE_URL}?${params.toString()}`
    );
    return response.data;
  },

  /**
   * Récupère un utilisateur par son ID
   */
  async getById(id: number): Promise<User> {
    const response = await api.get<User>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Crée un utilisateur (Keycloak + base BPA)
   */
  async create(data: CreateUserDto): Promise<User> {
    const response = await api.post<User>(BASE_URL, data);
    return response.data;
  },

  /**
   * Met à jour un utilisateur
   */
  async update(id: number, data: UpdateUserDto): Promise<User> {
    const response = await api.put<User>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  /**
   * Supprime un utilisateur (soft delete)
   */
  async delete(id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${id}`);
  },
};
